import React, { useState } from "react";

interface UploadButtonProps {
  label: string;
  onUpload: (file: File | null, index: number) => Promise<string | null>;
  onRemove: (index: number) => void;
  accept?: string;
  index: number;
}

const UploadButton: React.FC<UploadButtonProps> = ({
  label,
  onUpload,
  onRemove,
  accept,
  index,
}) => {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isUploading, setIsUploading] = useState<boolean>(false);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;

    if (file) {
      console.log("File selected:", file);
      setIsUploading(true);

      try {
        const uploadedUrl = await onUpload(file, index);

        console.log("uploadedUrl", uploadedUrl);

        if (uploadedUrl) {
          setUploadedFile(file);
          setErrorMessage(null);
        } else {
          setUploadedFile(null);
          setErrorMessage("Failed to upload file.");
        }
      } catch (error) {
        console.error("Upload failed:", error);
        setUploadedFile(null);
        setErrorMessage("An error occurred while uploading.");
      } finally {
        setIsUploading(false);
      }
    }

    e.target.value = "";
  };

  const handleRemoveFile = () => {
    setUploadedFile(null);
    setErrorMessage(null);
    onRemove(index);
  };

  return (
    <div className="flex flex-col items-center">
      <div
        className="relative flex items-center justify-center border border-dashed 
                border-gray-300 rounded-md h-28 w-30 bg-gray-50 cursor-pointer hover:bg-gray-100"
      >
        <label className="flex flex-col items-center justify-center text-center text-gray-500 text-sm cursor-pointer">
          <span className="text-xl font-bold">+</span>
          <span className="truncate max-w-full text-xs px-2">{label}</span>
          <input
            type="file"
            accept={accept}
            className="hidden"
            onChange={handleFileChange}
            disabled={isUploading}
          />
        </label>
      </div>

      {errorMessage && (
        <div className="text-red-500 text-sm mt-2">{errorMessage}</div>
      )}

      {!isUploading && uploadedFile && !errorMessage && (
        <div className="mt-4 flex items-center space-x-2">
          <span
            className="truncate w-14 text-gray-700 text-sm"
            title={uploadedFile.name}
          >
            {uploadedFile.name}
          </span>
          <button
            onClick={handleRemoveFile}
            className="text-red-500 text-sm font-bold hover:underline"
          >
            ×
          </button>
        </div>
      )}

      {isUploading && (
        <div className="text-gray-500 text-sm mt-2">Uploading...</div>
      )}
    </div>
  );
};

export default UploadButton;
